module.exports = __webpack_public_path__ + "static/media/smile.1b3eedc2.png";